import React from 'react'
import './info2.scss';

function Info2() {
    return (
        <div class="info-template">
        <h1 class="h1-heading text-center d-flex">Asociația Terapeutică de Intervenție, Psihoterapie Individuală și Comportamentală</h1>
        <h2 class="h2-heading  text-center text-muted">Terapie ABA și Psihoterapie</h2>
        <div></div>
    </div>
    )
}

export default Info2

